import React, { Component } from 'react';
import { Container, Row, Col, Button ,Image} from "react-bootstrap";

class ErrorViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {

        }
    }

    componentDidMount = async () => {
        console.log(`Envoirment ${process.env.REACT_APP_MODE}`)
    }


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }



    render = () => {
        return (
            <Container className="error-page">
                <Row >
                    <Col md={{ span: 2, offset: 5 }} >
                        <Image src="./assets/logo.svg"  />
                    </Col>
                </Row><br/>
                <Row >
                    
                    <Col md={{ span: 4, offset: 4 }} className="">
                    <h1>Oops!</h1>
                        <h2>404</h2>
                        <h3>Page not found</h3>
                    </Col>
                </Row>
                <Row >
                    <Col md={2}></Col>
                    <Col md={4} >
                        <a href="/" className="btn btn-outline-primary">Take me home</a>
          
                    </Col>
                    <Col md={4} >
                           <a href="/contact" className="btn btn-outline-primary">Contact support</a>
                    </Col>
                    <Col md={2}></Col>
                </Row>
            
            </Container>
        );
    };



}


/* Export Component ==================================================================== */
export default ErrorViewContainer;